import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const SearchableSelect = ({ options, value, onChange, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);

    const selectedOption = options.find(option => option.value === value);

    const styles = {
        wrapper: { position: 'relative', fontFamily: 'IRANSans, sans-serif' },
        header: {
            padding: '0.75rem', fontSize: '1rem', border: '1px solid #ccc',
            borderRadius: '4px', cursor: 'pointer', display: 'flex',
            justifyContent: 'space-between', alignItems: 'center',
            backgroundColor: '#627388', color: '#ffffffff',
        },
        dropdown: {
            position: 'absolute', top: '100%', left: 0, right: 0,
            border: '1px solid #ccc', borderRadius: '4px',
            backgroundColor: '#627388', zIndex: 10, marginTop: '4px',
            maxHeight: '250px',
        },
        searchInput: {
            width: '100%', padding: '0.75rem', border: 'none',
            borderBottom: '1px solid #eee', boxSizing: 'border-box',
            fontSize: '1rem', outline: 'none'
        },
        optionsContainer: {
            maxHeight: '200px', overflowY: 'auto'
        },
        option: {
            padding: '0.75rem', cursor: 'pointer',
        },
        placeholder: { color: '#888' }
    };

    // Hook to handle clicks outside of the component
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    
    const filteredOptions = options.filter(option => 
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelectOption = (optionValue) => {
        onChange(optionValue);
        setIsOpen(false);
        setSearchTerm('');
    };

    return (
        <div style={styles.wrapper} ref={wrapperRef}>
            <div style={styles.header} onClick={() => setIsOpen(!isOpen)}>
                <span style={selectedOption ? {} : styles.placeholder}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <FaChevronDown style={{ transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}/>
            </div>
            {isOpen && (
                <div style={styles.dropdown}>
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder="جستجو..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        autoFocus
                    />
                    <div style={styles.optionsContainer}>
                        {filteredOptions.length > 0 ? filteredOptions.map(option => (
                            <div
                                key={option.value}
                                style={styles.option}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#424458ff'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#627388'}
                                onClick={() => handleSelectOption(option.value)}
                            >
                                {option.label}
                            </div>
                        )) : <div style={styles.option}>موردی یافت نشد</div>}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchableSelect;